import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Profile from 'components/organisms/Profiles/Profile/Profile';

const StyledTaskProfile = styled(Profile)`
  ${ComponentStyles}
`;

StyledTaskProfile.propTypes = {
  theme: PropTypes.object
};

export default StyledTaskProfile;
